module.exports = __webpack_public_path__ + "img/paper-medium_blue-sm-min.f147d2c2.jpg";